import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { routesConfig } from "./routes/routesConfig.js";
import { ROUTES_PUBLIC } from "./routes/routesMap.js";

import { logout, validarToken } from "./api/LoginApi.js";

import Login from "./components/Login";

import { useTranslation } from 'react-i18next';
import { useConfirmacion } from "./components/useConfirmacion.js";

function App() {
  	const { t } = useTranslation();
  	const [isAuth, setIsAuth] = useState(null);
  	const { confirm, ConfirmacionDialog } = useConfirmacion();

  	const handleLogin = () => setIsAuth(true);

	useEffect(() => {

		const verifyToken = async () => {

			try {
				await validarToken();
				setIsAuth(true);

			} catch {
				setIsAuth(false);
			}
		};

    	verifyToken();

  	}, []);

	if(isAuth === null) return;
  	if(!isAuth) return <Login onLogin={handleLogin} />;

  	const handleLogout = async () => {
    	const confirmed = await confirm(t('general.confirm_logout'));
    	if(!confirmed) return;

		logout();
    	setIsAuth(false);
  	};

	//

  	return (
    	<>
			<BrowserRouter>            
				<Routes>

					{routesConfig.map(e => (
						<Route key={e.path} path={e.path} element={React.cloneElement(e.element, { onLogout: handleLogout })}  />
					))}

					{/* Redirecciona al inicio sino existe la vista */}
					<Route path="*" element={<Navigate to={ROUTES_PUBLIC.base} replace />} />
					
				</Routes>
			</BrowserRouter>
			{ConfirmacionDialog}
    	</>
  	);
}

export default App;
